<div class="table-responsive settings-table-shell settings-reference-table settings-user-management-table-shell rounded-4 border border-danger-subtle bg-danger bg-opacity-10 shadow-sm">
    <div v-if="is_loading" class="d-flex align-items-center gap-3 text-muted p-3">
        <div class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></div>
        <span class="text-xs">Loading users...</span>
    </div>

    <div v-else-if="!users.length" class="text-center py-4 text-xs">
        <div class="d-flex flex-column align-items-center justify-content-center py-4">
            <span class="d-inline-flex align-items-center justify-content-center rounded-circle border bg-light text-dark mb-3" style="width: 2.5rem; height: 2.5rem;">
                <i class="bi bi-people-fill"></i>
            </span>
            <p class="fw-semibold mb-1">No users available</p>
            <p class="text-xs mb-0">Added users will appear here.</p>
        </div>
    </div>

    <table
        v-else
        class="table table-hover align-middle mb-0 settings-data-table global_data_table text-xs"
        data-search-placeholder="Search users"
        data-non-orderable-targets="[7]"
        data-page-length="5"
        data-order-column="0"
        data-order-direction="asc"
    >
        <thead>
            <tr>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis">User</th>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis">Email</th>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis">Role</th>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis">Properties</th>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis">Status</th>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis">Session</th>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis">Last Login</th>
                <th scope="col" class="settings-table-head fw-semibold text-xs text-danger-emphasis text-end">Actions</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="user in users" :key="user.id">
                <td data-label="Member" class="settings-user-member-cell">
                    <div class="d-flex align-items-center gap-2">
                        <span class="settings-user-avatar d-inline-flex align-items-center justify-content-center rounded-circle">
                            {{ get_initials(user) }}
                        </span>
                        <div class="d-flex flex-column gap-1">
                            <span class="fw-semibold text-xs">{{ get_full_name(user) }}</span>
                            <span class="settings-user-mobile-email text-xs">{{ user.email || "-" }}</span>
                        </div>
                    </div>
                </td>
                <td data-label="Email" class="fw-semibold text-xs settings-user-email-cell">{{ user.email || "-" }}</td>
                <td data-label="Role">
                    <span class="badge rounded-pill text-bg-info bg-opacity-25 border border-info border-opacity-25 small text-dark">
                        {{ user.role || "-" }}
                    </span>
                </td>
                <td data-label="Properties" class="text-xs settings-user-properties-cell">{{ get_property_summary(user) }}</td>
                <td data-label="Status">
                    <span
                        class="badge rounded-pill small text-dark"
                        :class="user.is_active ? 'text-bg-success bg-opacity-25 border border-success border-opacity-25' : 'text-bg-secondary bg-opacity-25 border border-secondary-subtle'"
                    >
                        {{ user.is_active ? "Active" : "Inactive" }}
                    </span>
                </td>
                <td data-label="Session">
                    <span
                        class="badge rounded-pill small text-dark"
                        :class="get_session_badge_class(user)"
                        :title="get_session_title(user)"
                    >
                        {{ get_session_label(user) }}
                    </span>
                </td>
                <td data-label="Last Login" class="text-xs settings-user-last-login-cell">
                    {{ get_last_login_label(user) }}
                </td>
                <td data-label="Actions" class="settings-user-actions-cell">
                    <div class="d-flex justify-content-end gap-2 flex-wrap">
                        <button
                            type="button"
                            class="btn btn-outline-danger btn-sm rounded-3 d-inline-flex align-items-center gap-1 px-3 shadow-sm settings-user-edit-action"
                            @click="open_edit_user(user)"
                            aria-label="Edit user"
                        >
                            <i class="bi bi-pencil-square text-xs"></i>
                            <span class="text-xs">Edit</span>
                        </button>

                        <button
                            type="button"
                            :class="['btn btn-sm rounded-3 d-inline-flex align-items-center gap-1 px-3 shadow-sm settings-user-status-action', user.is_active ? 'btn-warning' : 'btn-success']"
                            @click="toggle_user_status(user)"
                            :disabled="is_busy || (is_current_user(user) && user.is_active) || (!user.is_active && !has_users_endpoint)"
                            :aria-label="user.is_active ? 'Deactivate user' : 'Activate user'"
                            :title="get_status_action_title(user)"
                        >
                            <span v-if="is_user_status_updating(user)" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="text-xs">{{ user.is_active ? "Deactivate" : "Activate" }}</span>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
